import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { ProductCard } from "../components/Cards";
import { Meta } from "../components/Meta";
import { SearchForm } from "../components/SearchForm";
import { routes } from "../config/routes";
import { searchProducts, visibleProducts } from "../data/catalogue";

export function SearchPage() {
  const [params] = useSearchParams();
  const query = params.get("q") ?? "";
  const listings = visibleProducts();
  const results = useMemo(() => searchProducts(query), [query]);

  return (
    <main id="main">
      <Meta
        title={query ? `Search “${query}” | Beautify Ourselves` : "Search | Beautify Ourselves"}
        description="Search the Beautify Ourselves preview catalogue. Orders are not currently available."
        path={query ? `${routes.search}?q=${encodeURIComponent(query)}` : routes.search}
      />
      <header className="page-hero page-hero-compact">
        <div className="page-hero-inner">
          <p className="eyebrow">Search</p>
          <h1>{query ? `Results for “${query}”` : "Search the collection"}</h1>
          <SearchForm id="search-page-q" initialQuery={query} />
        </div>
      </header>
      <section className="section shop-catalogue">
        <div className="section-inner">
          {listings.length === 0 ? (
            <div className="empty-state">
              <h2>The collection is still being prepared</h2>
              <p>Search will show listings when the preview catalogue is available.</p>
            </div>
          ) : results.length === 0 ? (
            <div className="empty-state">
              <h2>No matching listings</h2>
              <p>Try a different name, brand or category. Nothing is hidden behind a discount or rating filter.</p>
            </div>
          ) : (
            <>
              <p aria-live="polite">
                {results.length} {results.length === 1 ? "listing" : "listings"}
              </p>
              <div className="product-grid">
                {results.map((product) => (
                  <ProductCard key={product.id} product={product} />
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </main>
  );
}
